<template>
  <div>
    <div id="videoPlayer">
      <div class="content my-3 mb-5">
        <div class="audio container mx-auto max-w-4xl">
          <div class="flex justify-end w-full py-3 cursor-pointer" @click="changeSection">
            <div class="closeVideo">
              <img src="~@/assets/btn/btn_close_black.png" alt="Close" />
            </div>
          </div>
          <div v-if="fileType === 'youtube'">
            <iframe
              width="560"
              height="315"
              :src="videoUrl"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>
          <div v-if="fileType === 'audio'" class="audio-player flex flex-col items-center max-w-4xl bg-black">
            <div>
              <img :src="audioTypeCover" alt="cover" style="width: 300px; height: auto;">
            </div>
            <audio controls controlsList="nodownload" :src="videoUrl" :loop="isLoop" class="w-full rounded-none" style="border-radius: 0 !important;"></audio>
          </div>
          <div v-else>
            <playerVideoModule
              :volume="volume"
              ref="video"
              :videoSrc="videoUrl"
              :isLoop="isLoop"
              :poster="audioTypeCover"
              >
            </playerVideoModule>
          </div>
        </div>
        <a class="inline-flex items-center px-2 py-1 loopBtn cursor-pointer mt-2 fs14"
          :class="{ 'loopBtn-active': isLoop }"
          @click="toggleLoop">
          <img v-if="isLoop" class="object-contain" src="~@/assets/icon/repeat_on.png">
          <img v-if="!isLoop" class="object-contain" src="~@/assets/icon/repeat_off.png">
          重複播放
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, nextTick } from 'vue'
import playerVideoModule from '@/components/modules/playerVideoModule.vue'

export default {
  name: 'ToggleType',
  props: {
    path: {
      type: String,
      required: true,
    },
    fileUrl: {
      type: String,
      required: true,
    },
    fileType: {
      type: String,
      required: true,
    },
    audioCover: String,
  },
  components: {
    playerVideoModule,
  },
  setup (props, { emit }) {
    const isLoop = ref(false)
    const volume = ref(localStorage.getItem('volume') || 1)

    const videoUrl = computed(() => {
      if (props.fileUrl.includes('https')) {
        return props.fileUrl
      } else if (props.fileType === 'youtube') {
        return props.fileUrl
      } else {
        return `${props.path}/${props.fileUrl}`
      }
    })

    const audioTypeCover = computed(() => {
      if (props.fileType === 'audio') {
        return props.audioCover
      } else {
        return ''
      }
    })

    const toggleLoop = async () => {
      isLoop.value = !isLoop.value
      await nextTick()
      const video = document.querySelector('playerVideoModule')
      if (video) {
        video.setLoop(isLoop.value)
      }
    }

    const changeSection = () => {
      emit('changeSection', 2)
    }

    return {
      isLoop,
      volume,
      videoUrl,
      toggleLoop,
      changeSection,
      audioTypeCover
    }
  },
}
</script>

<style scoped lang="scss">
iframe {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
}
.loopBtn {
  color: rgba(102, 102, 102, 0.6);
  border-radius: 0.35rem;
  border: 2px solid rgba(102, 102, 102, 0.6);
}
.loopBtn-active {
  color: #E71B1B !important;
  border: 2px solid #E71B1B;
  background: #F5E1E1;
}
.closeVideo {
  cursor: pointer;
  max-width: 40px;
  max-height: 40px;
  border: 1px solid #000;
  border-radius: 50%;
  padding: 4px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

audio {
  border-radius: 0 !important;
  background-color: #F1F3F4 !important;
}

</style>
